import { axiosInstanceWebsite } from "../instance";

export interface MetaIntegration {
  id: number;
  owner_id: string;
  is_active: boolean;
  ad_account_id: string | null;
  business_id: string | null;
  business_name: string | null;
  expires_at: number | null;
  created_at: string;
  updated_at: string;
}

export interface MetaOAuthUrlResponse {
  authorizationUrl: string;
}

export interface MetaAdAccount {
  id: string;
  name: string;
  account_status: number;
  currency?: string;
  timezone_name?: string;
}

export interface MetaAdAccountsResponse {
  ok: boolean;
  adaccounts: MetaAdAccount[];
}

export const getMetaIntegration = async (): Promise<MetaIntegration | null> => {
  const response = await axiosInstanceWebsite.get("/meta/integration");
  return response.data;
};

export const getMetaOAuthUrl = async (): Promise<MetaOAuthUrlResponse> => {
  const response = await axiosInstanceWebsite.get("/meta/oauth/url");
  return response.data;
};

export const getMetaAdAccounts = async (): Promise<MetaAdAccountsResponse> => {
  const response = await axiosInstanceWebsite.get("/meta/ad-accounts");
  return response.data;
};

export const updateMetaAdAccount = async (adAccountId: string): Promise<MetaIntegration> => {
  const response = await axiosInstanceWebsite.put("/meta/integration/ad-account", {
    ad_account_id: adAccountId,
  });
  return response.data;
};

export interface CampaignMetricsResponse {
  ok: boolean;
  ad_account_id: string;
  date_preset: string;
  active_ads_count: number;
  running_campaigns: string[];
  reach: number;
  frequency: number;
  impressions: number;
  video_3s: number;
  video_50: number;
  link_clicks: number;
}

export const getCampaignMetrics = async (
  adAccountId: string,
  datePreset: string = "last_7d"
): Promise<CampaignMetricsResponse> => {
  const response = await axiosInstanceWebsite.get(
    `/meta/campaigns/${adAccountId}/metrics`,
    { params: { date_preset: datePreset } }
  );
  return response.data;
};

export const disconnectMetaIntegration = async (): Promise<MetaIntegration> => {
  const response = await axiosInstanceWebsite.post("/meta/integration", {
    isActive: false,
  });
  return response.data;
};
